import { render, staticRenderFns } from "./select-org-ips.vue?vue&type=template&id=13adeb07&scoped=true&"
import script from "./select-org-ips.vue?vue&type=script&lang=js&"
export * from "./select-org-ips.vue?vue&type=script&lang=js&"
import style0 from "./select-org-ips.vue?vue&type=style&index=0&id=13adeb07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13adeb07",
  null
  
)

export default component.exports